import React from "react";
import { useSelector } from "react-redux";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { RefundTablePage } from "./refundTable/RefundTablePage";
import { RefundFilterPage } from "./refundFilter/RefundFilterPage";

import { selectRefundState } from "../../store/refund/refundFilterSlice";
import {
  selectRefunds,
  useGetRefundListQuery,
} from "../../services/refund/refundApiSlice";
import classes from "./refundListPage.module.css";

export const RefundListPage = () => {
  const appliedFilters = useSelector(selectRefundState);
  const { isSuccess } = useGetRefundListQuery(appliedFilters);

  const tableData = useSelector(selectRefunds);

  return isSuccess ? (
    <div className={classes.box}>
      <RefundFilterPage />
      <RefundTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
